const P = {
  POP: "POP"
};
export {
  P as HISTORY_ACTION_TYPE
};
